import React, { useEffect, useState } from "react"
import { useAuth0 } from "@auth0/auth0-react"
import { Button, Card } from "antd"
import { GoogleOutlined } from "@ant-design/icons"
import axios from "axios"
import { apiBaseUrl } from "../config"

const Login = () => {
  const { loginWithRedirect, user, isAuthenticated, isLoading } = useAuth0()

  useEffect(() => {
    if (isAuthenticated && user) {
      fetchUser(user?.email)
    }
  }, [])

  const fetchUser = async (email : string | undefined) => {
    try {
      if (!email) return
      const userData = await axios.get(`${apiBaseUrl}/api/user?email=${email}`)
      // @ts-ignore
      if (userData.exists) {
        // Redirect to home page
        window.location.href = "/"
      }
    } catch (error) {
      console.error("Error fetching user data:", error)
    }
  }

  const handleGoogleLogin = async () => {
    await loginWithRedirect({
      authorizationParams: {
        connection: 'google-oauth2',
      }
    })
  }

  return (
    <div className="flex justify-center items-center h-screen bg-gray-100">
      <Card className="w-80 p-6 text-center shadow-lg">
        <div className="flex flex-col items-center font-semibold mb-8">
          <img src="/logo_meru.svg" alt="Logo" className="h-10" />
          <h2 className="text-xl">Flowsheet Data Entry</h2>
        </div>
        <Button
          type="primary"
          icon={<GoogleOutlined />}
          className="w-full bg-blue-500 hover:bg-blue-600 text-white p-5"
          onClick={handleGoogleLogin}
        >
          Register/Log in with Google
        </Button>
      </Card>
    </div>
  );
};

export default Login;